import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = theme => ({
  button: {
    alignSelf: 'center',
    padding: '.9rem 2rem',
    border: `1.69px solid ${theme.palette.primary.main}`,
    boxShadow: '0 30px 31px -10px rgba(0,0,0,0.15)',
    '&:hover': {
      borderColor: theme.palette.primary.dark,
      color: '#fff',
      backgroundColor: 'rgb(148, 0, 29)'
    },
    '&:active': {
      borderColor: theme.palette.primary.dark,
      color: '#fff',
      backgroundColor: 'rgb(148, 0, 29)'
    },
    '&:focus': {
      borderColor: theme.palette.primary.dark,
      color: '#fff',
      backgroundColor: 'rgb(148, 0, 29)'
    },
    margin: 'auto'
  },
  buttonLabel: {
    fontWeight: 'bold'
  }
});

class BuyButton extends React.Component {
  constructor(props) {
    super(props);
  }

  toggleButtonHover = buttonHover => e => {
    this.setState({ buttonHover });
  };

  render() {
    const { classes, onClick } = this.props;
    return (
      <div>
        <Button
          classes={{ label: `${classes.buttonLabel}` }}
          className={`${classes.button} btn-padding-sm`}
          color="primary"
          component="a"
          onClick={onClick}
        >
          BUY MEMBERSHIP
        </Button>
      </div>
    );
  }
}

BuyButton.propTypes = {
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
};

export default withStyles(styles)(BuyButton);
